export default __webpack_public_path__ + "static/media/pngwing4.9960b680.png";